import { mockCourses, categories } from './viags';
import courseModulesData from './data/courseModules.json';
import availableModulesData from './data/availableModules.json';
import modulesData from './data/modules.json';
import moduleDetailData from './data/moduleDetail.json';
import moduleEditData from './data/moduleEdit.json';
import subjectsData from './data/subjects.json';
import subjectDetailData from './data/subjectDetail.json';
import classesData from './data/classes.json';
import classDetailData from './data/classDetail.json';
import assessmentsData from './data/assessments.json';
import createCoursesData from './data/createCourses.json';
import teachersData from './data/teachers.json';
import studentsData from './data/students.json';
import organizationData from './data/organization.json';
import instructorsData from './data/instructors.json';
import facilitiesData from './data/facilities.json';
import certificationsData from './data/certifications.json';
import certificationTypesData from './data/certificationTypes.json';
import certificationReportsData from './data/certificationReports.json';
import expiringCertificationsData from './data/expiringCertifications.json';
import notificationSettingsData from './data/notificationSettings.json';
import certificationDashboardData from './data/certificationDashboard.json';
import trainingNeedsData from './data/trainingNeeds.json';
import trainingPlansData from './data/trainingPlans.json';
import trainingPlansDetailData from './data/trainingPlansDetail.json';
import trainingSchedulesData from './data/trainingSchedules.json';
import annualTrainingPlansData from './data/annualTrainingPlans.json';
import orgUnitsData from './data/orgUnits.json';
import scheduleRunsData from './data/scheduleRuns.json';
import draftClassesData from './data/draftClasses.json';
import auditLogsData from './data/auditLogs.json';
import availableInstructorsData from './data/availableInstructors.json';
import availableRoomsData from './data/availableRooms.json';
import learningMapData from './data/learningMapData.json';

// Mock data for schedule detail page fallback
const mockScheduleDetailClasses = [
  {
    id: 'CLASS001',
    title: 'Kỹ thuật bảo trì - Khóa 1',
    code: 'COURSE001',
    instructor: 'Nguyễn Văn Thắng',
    startDate: '2025-09-15',
    endDate: '2025-09-16',
    duration: '2 buổi',
    location: 'Sân bay thực tập - Nội Bài (HAN)',
    enrolledStudents: 29,
    maxStudents: 40,
    status: 'draft',
    priority: 'critical',
    conflictFlag: true,
    unit: 'Chi nhánh Nội Bài',
    trainingType: 'Ban đầu'
  },
  {
    id: 'CLASS002',
    title: 'Cứu hộ cứu nạn - Khóa 2',
    code: 'COURSE002',
    instructor: 'Lê Minh Đức',
    startDate: '2025-09-16',
    endDate: '2025-09-19',
    duration: '4 buổi',
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    enrolledStudents: 22,
    maxStudents: 34,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    unit: 'Chi nhánh Đà Nẵng',
    trainingType: 'Định kỳ'
  }
];

const mockScheduleDetailSessions = [
  // Chi nhánh Nội Bài
  {
    id: 'SESSION001_1',
    courseId: 'CLASS001',
    courseName: 'Kỹ thuật bảo trì - Khóa 1',
    sessionName: 'Lý thuyết Kỹ thuật bảo trì',
    type: 'theory',
    instructor: 'Nguyễn Văn Thắng',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-02',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Sân bay thực tập - Nội Bài (HAN)',
    maxStudents: 40,
    enrolledStudents: 29,
    status: 'draft',
    priority: 'critical',
    conflictFlag: true,
    description: 'Lý thuyết Kỹ thuật bảo trì'
  },
  {
    id: 'SESSION001_2',
    courseId: 'CLASS001',
    courseName: 'Kỹ thuật bảo trì - Khóa 1',
    sessionName: 'Thực hành Kỹ thuật bảo trì - Phần 1',
    type: 'practice',
    instructor: 'Nguyễn Văn Thắng',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-03',
    timeSlot: { start: '10:00', end: '12:00' },
    duration: 120,
    location: 'Sân bay thực tập - Nội Bài (HAN)',
    maxStudents: 40,
    enrolledStudents: 29,
    status: 'draft',
    priority: 'critical',
    conflictFlag: false,
    description: 'Thực hành Kỹ thuật bảo trì - Phần 1'
  },
  // Chi nhánh Đà Nẵng
  {
    id: 'SESSION002_1',
    courseId: 'CLASS002',
    courseName: 'Cứu hộ cứu nạn - Khóa 2',
    sessionName: 'Lý thuyết Cứu hộ cứu nạn',
    type: 'theory',
    instructor: 'Lê Minh Đức',
    unit: 'Chi nhánh Đà Nẵng',
    date: '2025-09-04',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    maxStudents: 34,
    enrolledStudents: 22,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    description: 'Lý thuyết Cứu hộ cứu nạn'
  },
  {
    id: 'SESSION002_2',
    courseId: 'CLASS002',
    courseName: 'Cứu hộ cứu nạn - Khóa 2',
    sessionName: 'Thực hành Cứu hộ cứu nạn - Phần 1',
    type: 'practice',
    instructor: 'Lê Minh Đức',
    unit: 'Chi nhánh Đà Nẵng',
    date: '2025-09-05',
    timeSlot: { start: '13:00', end: '17:00' },
    duration: 240,
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    maxStudents: 34,
    enrolledStudents: 22,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    description: 'Thực hành Cứu hộ cứu nạn - Phần 1'
  },
  // Chi nhánh Tân Sơn Nhất
  {
    id: 'SESSION003_1',
    courseId: 'CLASS003',
    courseName: 'An toàn bay nâng cao - Khóa 3',
    sessionName: 'Lý thuyết An toàn bay',
    type: 'theory',
    instructor: 'Trần Thị Hòa',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-06',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Phòng họp An ninh - Tân Sơn Nhất (SGN)',
    maxStudents: 25,
    enrolledStudents: 20,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: false,
    description: 'Lý thuyết An toàn bay nâng cao'
  },
  // Chi nhánh Nội Bài
  {
    id: 'SESSION004_1',
    courseId: 'CLASS004',
    courseName: 'Phát triển kỹ năng lãnh đạo - Khóa 4',
    sessionName: 'Workshop Lãnh đạo',
    type: 'workshop',
    instructor: 'Phạm Thị An',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-09',
    timeSlot: { start: '13:00', end: '17:00' },
    duration: 240,
    location: 'Phòng mô phỏng A320 - Nội Bài (HAN)',
    maxStudents: 15,
    enrolledStudents: 12,
    status: 'draft',
    priority: 'medium',
    conflictFlag: false,
    description: 'Workshop phát triển kỹ năng lãnh đạo'
  },
  // Chi nhánh Tân Sơn Nhất
  {
    id: 'SESSION005_1',
    courseId: 'CLASS005',
    courseName: 'Bảo dưỡng máy bay cơ bản - Khóa 5',
    sessionName: 'Lý thuyết Bảo dưỡng',
    type: 'theory',
    instructor: 'Hoàng Văn Nam',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-10',
    timeSlot: { start: '08:00', end: '12:00' },
    duration: 240,
    location: 'Kho đào tạo xử lý hành lý - Tân Sơn Nhất (SGN)',
    maxStudents: 20,
    enrolledStudents: 18,
    status: 'in_progress',
    priority: 'critical',
    conflictFlag: true,
    description: 'Lý thuyết bảo dưỡng máy bay cơ bản'
  },
  // Thêm một số session khác để có đủ dữ liệu cho tháng 9
  {
    id: 'SESSION006_1',
    courseId: 'CLASS006',
    courseName: 'An ninh hàng không - Khóa 6',
    sessionName: 'Lý thuyết An ninh',
    type: 'theory',
    instructor: 'Nguyễn Văn Thắng',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-11',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Phòng mô phỏng A320 - Nội Bài (HAN)',
    maxStudents: 30,
    enrolledStudents: 25,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: false,
    description: 'Lý thuyết An ninh hàng không'
  },
  {
    id: 'SESSION007_1',
    courseId: 'CLASS007',
    courseName: 'Xử lý hành lý - Khóa 7',
    sessionName: 'Thực hành Xử lý hành lý',
    type: 'practice',
    instructor: 'Lê Minh Đức',
    unit: 'Chi nhánh Đà Nẵng',
    date: '2025-09-12',
    timeSlot: { start: '10:00', end: '12:00' },
    duration: 120,
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    maxStudents: 25,
    enrolledStudents: 20,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    description: 'Thực hành Xử lý hành lý'
  },
  {
    id: 'SESSION008_1',
    courseId: 'CLASS008',
    courseName: 'Điều hành bay - Khóa 8',
    sessionName: 'Lý thuyết Điều hành bay',
    type: 'theory',
    instructor: 'Trần Thị Hòa',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-13',
    timeSlot: { start: '13:00', end: '15:00' },
    duration: 120,
    location: 'Phòng họp An ninh - Tân Sơn Nhất (SGN)',
    maxStudents: 20,
    enrolledStudents: 18,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: false,
    description: 'Lý thuyết Điều hành bay'
  },
  {
    id: 'SESSION009_1',
    courseId: 'CLASS009',
    courseName: 'Dịch vụ khách hàng - Khóa 9',
    sessionName: 'Workshop Dịch vụ khách hàng',
    type: 'workshop',
    instructor: 'Phạm Thị An',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-16',
    timeSlot: { start: '15:00', end: '17:00' },
    duration: 120,
    location: 'Phòng mô phỏng A320 - Nội Bài (HAN)',
    maxStudents: 15,
    enrolledStudents: 12,
    status: 'draft',
    priority: 'medium',
    conflictFlag: false,
    description: 'Workshop Dịch vụ khách hàng'
  },
  {
    id: 'SESSION010_1',
    courseId: 'CLASS010',
    courseName: 'Quản lý chất lượng - Khóa 10',
    sessionName: 'Lý thuyết Quản lý chất lượng',
    type: 'theory',
    instructor: 'Hoàng Văn Nam',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-17',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Kho đào tạo xử lý hành lý - Tân Sơn Nhất (SGN)',
    maxStudents: 25,
    enrolledStudents: 22,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    description: 'Lý thuyết Quản lý chất lượng'
  },
  {
    id: 'SESSION011_1',
    courseId: 'CLASS011',
    courseName: 'Cứu hộ cứu nạn nâng cao - Khóa 11',
    sessionName: 'Thực hành Cứu hộ nâng cao',
    type: 'practice',
    instructor: 'Lê Minh Đức',
    unit: 'Chi nhánh Đà Nẵng',
    date: '2025-09-18',
    timeSlot: { start: '10:00', end: '12:00' },
    duration: 120,
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    maxStudents: 20,
    enrolledStudents: 16,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: true,
    description: 'Thực hành Cứu hộ cứu nạn nâng cao'
  },
  {
    id: 'SESSION012_1',
    courseId: 'CLASS012',
    courseName: 'Bảo trì thiết bị - Khóa 12',
    sessionName: 'Lý thuyết Bảo trì thiết bị',
    type: 'theory',
    instructor: 'Nguyễn Văn Thắng',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-19',
    timeSlot: { start: '13:00', end: '15:00' },
    duration: 120,
    location: 'Sân bay thực tập - Nội Bài (HAN)',
    maxStudents: 30,
    enrolledStudents: 28,
    status: 'scheduled',
    priority: 'critical',
    conflictFlag: false,
    description: 'Lý thuyết Bảo trì thiết bị'
  },
  {
    id: 'SESSION013_1',
    courseId: 'CLASS013',
    courseName: 'An toàn lao động - Khóa 13',
    sessionName: 'Workshop An toàn lao động',
    type: 'workshop',
    instructor: 'Trần Thị Hòa',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-20',
    timeSlot: { start: '15:00', end: '17:00' },
    duration: 120,
    location: 'Phòng họp An ninh - Tân Sơn Nhất (SGN)',
    maxStudents: 25,
    enrolledStudents: 20,
    status: 'draft',
    priority: 'medium',
    conflictFlag: false,
    description: 'Workshop An toàn lao động'
  },
  {
    id: 'SESSION014_1',
    courseId: 'CLASS014',
    courseName: 'Kỹ năng giao tiếp - Khóa 14',
    sessionName: 'Thực hành Giao tiếp',
    type: 'practice',
    instructor: 'Phạm Thị An',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-23',
    timeSlot: { start: '08:00', end: '10:00' },
    duration: 120,
    location: 'Phòng mô phỏng A320 - Nội Bài (HAN)',
    maxStudents: 20,
    enrolledStudents: 18,
    status: 'scheduled',
    priority: 'medium',
    conflictFlag: false,
    description: 'Thực hành Kỹ năng giao tiếp'
  },
  {
    id: 'SESSION015_1',
    courseId: 'CLASS015',
    courseName: 'Quản lý tài liệu - Khóa 15',
    sessionName: 'Lý thuyết Quản lý tài liệu',
    type: 'theory',
    instructor: 'Hoàng Văn Nam',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-24',
    timeSlot: { start: '10:00', end: '12:00' },
    duration: 120,
    location: 'Kho đào tạo xử lý hành lý - Tân Sơn Nhất (SGN)',
    maxStudents: 30,
    enrolledStudents: 25,
    status: 'scheduled',
    priority: 'low',
    conflictFlag: false,
    description: 'Lý thuyết Quản lý tài liệu'
  },
  {
    id: 'SESSION016_1',
    courseId: 'CLASS016',
    courseName: 'Kiểm soát chất lượng - Khóa 16',
    sessionName: 'Thực hành Kiểm soát chất lượng',
    type: 'practice',
    instructor: 'Lê Minh Đức',
    unit: 'Chi nhánh Đà Nẵng',
    date: '2025-09-25',
    timeSlot: { start: '13:00', end: '15:00' },
    duration: 120,
    location: 'Phòng thực hành GSE - Đà Nẵng (DAD)',
    maxStudents: 25,
    enrolledStudents: 22,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: false,
    description: 'Thực hành Kiểm soát chất lượng'
  },
  {
    id: 'SESSION017_1',
    courseId: 'CLASS017',
    courseName: 'Ứng phó khẩn cấp - Khóa 17',
    sessionName: 'Workshop Ứng phó khẩn cấp',
    type: 'workshop',
    instructor: 'Nguyễn Văn Thắng',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-26',
    timeSlot: { start: '15:00', end: '17:00' },
    duration: 120,
    location: 'Sân bay thực tập - Nội Bài (HAN)',
    maxStudents: 20,
    enrolledStudents: 17,
    status: 'draft',
    priority: 'critical',
    conflictFlag: true,
    description: 'Workshop Ứng phó khẩn cấp'
  },
  {
    id: 'SESSION018_1',
    courseId: 'CLASS018',
    courseName: 'Đào tạo huấn luyện viên - Khóa 18',
    sessionName: 'Lý thuyết Đào tạo huấn luyện viên',
    type: 'theory',
    instructor: 'Trần Thị Hòa',
    unit: 'Chi nhánh Tân Sơn Nhất',
    date: '2025-09-27',
    timeSlot: { start: '08:00', end: '12:00' },
    duration: 240,
    location: 'Phòng họp An ninh - Tân Sơn Nhất (SGN)',
    maxStudents: 15,
    enrolledStudents: 12,
    status: 'scheduled',
    priority: 'high',
    conflictFlag: false,
    description: 'Lý thuyết Đào tạo huấn luyện viên'
  },
  {
    id: 'SESSION019_1',
    courseId: 'CLASS019',
    courseName: 'Phát triển cá nhân - Khóa 19',
    sessionName: 'Workshop Phát triển cá nhân',
    type: 'workshop',
    instructor: 'Phạm Thị An',
    unit: 'Chi nhánh Nội Bài',
    date: '2025-09-30',
    timeSlot: { start: '10:00', end: '12:00' },
    duration: 120,
    location: 'Phòng mô phỏng A320 - Nội Bài (HAN)',
    maxStudents: 20,
    enrolledStudents: 16,
    status: 'draft',
    priority: 'medium',
    conflictFlag: false,
    description: 'Workshop Phát triển cá nhân'
  }
];

export const dataProvider = {
  getData: () => {
    return {
      courses: mockCourses,
      classes: classesData,
    };
  },
  getCourses: (): any[] => {
    return mockCourses;
  },
  getCategories: (): string[] => {
    return categories;
  },
  getCourseModules: (courseId: string): any[] => {
    return courseModulesData;
  },
  getAvailableModules: (): any[] => {
    return availableModulesData;
  },
  getModules: (): any[] => {
    return modulesData;
  },
  getModuleDetail: (moduleId: string): any => {
    return moduleDetailData;
  },
  getModuleEdit: (moduleId: string): any => {
    return moduleEditData;
  },
  getSubjects: (): any[] => {
    return subjectsData;
  },
  getSubjectDetail: (subjectId: string): any => {
    return subjectDetailData;
  },
  getClasses: (): any[] => {
    return classesData;
  },
  getClassDetail: (classId: string): any => {
    return (classDetailData as any)[classId] || null;
  },
  getAssessments: (): any[] => {
    return assessmentsData;
  },
  getCreateCourses: (): any[] => {
    return createCoursesData;
  },
  getTeachers: (): any[] => {
    return teachersData;
  },
  getStudents: (): any[] => {
    return studentsData;
  },
  getOrganization: (): any[] => {
    return organizationData;
  },
  getInstructors: (): any[] => {
    return instructorsData;
  },
  getFacilities: (): any[] => {
    return facilitiesData;
  },
  getCertifications: (): any[] => {
    return certificationsData;
  },
  getCertificationTypes: (): any[] => {
    return certificationTypesData;
  },
  getCertificationReports: (): any => {
    return certificationReportsData;
  },
  getExpiringCertifications: (): any[] => {
    return expiringCertificationsData;
  },
  getNotificationSettings: (): any => {
    return notificationSettingsData;
  },
  getCertificationDashboard: (): any => {
    return certificationDashboardData;
  },
  getTrainingNeeds: (): any[] => {
    return trainingNeedsData;
  },
  getTrainingPlans: (): any[] => {
    return trainingPlansData;
  },
  getTrainingPlansDetail: (): any[] => {
    return trainingPlansDetailData;
  },
  getTrainingSchedules: (): any[] => {
    return trainingSchedulesData;
  },
  getAnnualTrainingPlans: (): any[] => {
    return annualTrainingPlansData;
  },
  getOrgUnits: (): any[] => {
    return orgUnitsData;
  },
  getScheduleRuns: (): any[] => {
    return scheduleRunsData;
  },
  getScheduleRun: (scheduleRunId: string): any => {
    return scheduleRunsData.find(schedule => schedule.id === scheduleRunId) || scheduleRunsData[0];
  },
  getDraftClasses: (scheduleRunId?: string): any[] => {    
    const classes = scheduleRunId 
      ? draftClassesData.filter(draftClass => draftClass.scheduleRunId === scheduleRunId)
      : draftClassesData;
      
    const result = classes.map(cls => {
      // Map unit based on location/room name to match the 3-branch structure
      let unit = 'Chi nhánh Tân Sơn Nhất';
      if (cls.sessions && cls.sessions.length > 0) {
        const roomName = cls.sessions[0].roomName;
        if (roomName.includes('Nội Bài') || roomName.includes('HAN')) {
          unit = 'Chi nhánh Nội Bài';
        } else if (roomName.includes('Đà Nẵng') || roomName.includes('DAD')) {
          unit = 'Chi nhánh Đà Nẵng';
        } else if (roomName.includes('Tân Sơn Nhất') || roomName.includes('SGN')) {
          unit = 'Chi nhánh Tân Sơn Nhất';
        }
      }

      // Map training type based on course title or type
      let trainingType = 'Ban đầu';
      if (cls.title.includes('Định kỳ') || cls.title.includes('tái chứng nhận') || cls.title.includes('recurrent')) {
        trainingType = 'Định kỳ';
      } else if (cls.title.includes('Phục hồi') || cls.title.includes('requalification') || cls.title.includes('refresher')) {
        trainingType = 'Phục hồi';
      } else if (cls.title.includes('Bồi dưỡng') || cls.title.includes('kỹ thuật') || cls.title.includes('technical')) {
        trainingType = 'Bồi dưỡng kỹ thuật';
      } else if (cls.title.includes('Khóa 1') || cls.title.includes('cơ bản') || cls.title.includes('initial')) {
        trainingType = 'Ban đầu';
      }

      return {
        id: cls.id,
        title: cls.title,
        description: cls.description,
        code: cls.courseId,
        instructor: cls.instructorName.replace(/^(Cơ trưởng|Chuyên viên|Thầy|Cô|Giáo sư|Tiến sĩ|Thạc sĩ|Kỹ sư|KTV)\s+/, ''),
        instructorId: cls.instructorId,
        unit: unit,
        startDate: cls.sessions?.[0]?.date || '',
        endDate: cls.sessions?.[cls.sessions.length - 1]?.date || '',
        duration: `${cls.sessions?.length || 0} buổi`,
        location: cls.sessions?.[0]?.roomName || 'TBA',
        enrolledStudents: cls.enrolledStudents,
        maxStudents: cls.maxStudents,
        status: cls.status,
        priority: cls.priority,
        conflictFlag: cls.conflictFlag,
        unassigned: cls.unassigned,
        requirements: cls.requirements,
        scheduleRunId: cls.scheduleRunId,
        courseId: cls.courseId,
        type: cls.type,
        sessions: cls.sessions,
        trainingType: trainingType
      };
    });
    
    return result;
  },
  getDraftSessions: (scheduleRunId?: string): any[] => {    
    const classes = scheduleRunId 
      ? draftClassesData.filter(draftClass => draftClass.scheduleRunId === scheduleRunId)
      : draftClassesData;
      
    const sessions: any[] = [];
    classes.forEach(draftClass => {
      // Map unit based on location/room name to match the 3-branch structure
      let unit = 'Chi nhánh Tân Sơn Nhất';
      if (draftClass.sessions && draftClass.sessions.length > 0) {
        const roomName = draftClass.sessions[0].roomName;
        if (roomName.includes('Nội Bài') || roomName.includes('HAN')) {
          unit = 'Chi nhánh Nội Bài';
        } else if (roomName.includes('Đà Nẵng') || roomName.includes('DAD')) {
          unit = 'Chi nhánh Đà Nẵng';
        } else if (roomName.includes('Tân Sơn Nhất') || roomName.includes('SGN')) {
          unit = 'Chi nhánh Tân Sơn Nhất';
        }
      }
      
      draftClass.sessions.forEach(session => {
        sessions.push({
          id: session.id,
          courseId: draftClass.id,
          courseName: draftClass.title,
          sessionName: session.title,
          type: session.type,
          instructor: draftClass.instructorName.replace(/^(Cơ trưởng|Chuyên viên|Thầy|Cô|Giáo sư|Tiến sĩ|Thạc sĩ|Kỹ sư|KTV)\s+/, ''),
          unit: unit, // Now uses dynamic unit mapping
          date: session.date,
          timeSlot: session.timeSlot,
          duration: session.duration,
          location: session.roomName,
          maxStudents: draftClass.maxStudents,
          enrolledStudents: draftClass.enrolledStudents,
          status: draftClass.status,
          priority: draftClass.priority,
          conflictFlag: draftClass.conflictFlag,
          description: session.title,
          scheduleRunId: draftClass.scheduleRunId,
          classId: draftClass.id,
          classTitle: draftClass.title,
          instructorId: draftClass.instructorId,
          instructorName: draftClass.instructorName.replace(/^(Cơ trưởng|Chuyên viên|Thầy|Cô|Giáo sư|Tiến sĩ|Thạc sĩ|Kỹ sư|KTV)\s+/, ''),
          requirements: draftClass.requirements,
          conflicts: (draftClass as any).conflicts,
          unassigned: draftClass.unassigned,
          isMultiDay: false
        });
      });
    });
    
    return sessions;
  },
  getAuditLogs: (scheduleRunId?: string): any[] => {
    return auditLogsData;
  },
  getAvailableInstructors: (): any[] => {
    return availableInstructorsData.map(instructor => ({
      ...instructor,
      name: instructor.name.replace(/^(Cơ trưởng|Chuyên viên|Thầy|Cô|Giáo sư|Tiến sĩ|Thạc sĩ|Kỹ sư|KTV)\s+/, '')
    }));
  },
  getAvailableRooms: (): any[] => {
    return availableRoomsData;
  },
  getLearningMapData: (): any => {
    return learningMapData;
  },
  getMockScheduleDetailClasses: (): any[] => {
    return mockScheduleDetailClasses;
  },
  getMockScheduleDetailSessions: (): any[] => {
    return mockScheduleDetailSessions;
  },
  getMockScheduleRun: (scheduleRunId: string, sessions: any[]): any => {
    return {
      id: scheduleRunId,
      name: 'Lịch đào tạo Q3/2025 - Dịch vụ mặt đất hàng không',
      status: 'draft_ready',
      version: 1,
      description: 'Lịch đào tạo cho các khóa học về dịch vụ mặt đất hàng không',
      stats: {
        totalSessions: sessions.length || 18,
        conflicts: sessions.filter(s => s.conflictFlag).length || 2,
        unassigned: sessions.filter(s => !s.instructorId || !s.location).length || 1,
        cost: 50000000
      }
    };
  },
  
  // Book management methods
  createBook: (bookData: any): Promise<any> => {
    return new Promise((resolve) => {
      // Simulate API delay
      setTimeout(() => {
        const newBook = {
          ...bookData,
        };
        
        // In a real app, this would make an API call
        // For now, we just simulate success
        resolve(newBook);
      }, 1000);
    });
  },
  
  updateBook: (bookId: string, bookData: any): Promise<any> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const updatedBook = {
          ...bookData,
          id: bookId,
          lastModified: new Date().toISOString().split('T')[0]
        };
        resolve(updatedBook);
      }, 800);
    });
  },
  
  deleteBook: (bookId: string): Promise<void> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        // In a real app, this would make an API call to delete
        resolve();
      }, 500);
    });
  },
  
  getBookById: (bookId: string): any => {
    return mockCourses.find(book => book.id === bookId) || null;
  },
  
  // Book content management methods
  getBookContents: (bookId: string): any[] => {
    // Mock book contents - in real app this would be an API call
    return [
      {
        id: 'content_1',
        title: 'Giới thiệu về hàng không',
        type: 'pdf',
        file: {
          name: 'gioi-thieu-hang-khong.pdf',
          size: 2048576,
          url: '#preview-pdf'
        },
        status: 'ready',
        order: 1,
        description: 'Tài liệu giới thiệu cơ bản về ngành hàng không'
      },
      {
        id: 'content_2',
        title: 'Video hướng dẫn an toàn bay',
        type: 'video',
        file: {
          name: 'huong-dan-an-toan-bay.mp4',
          size: 52428800,
          url: '#preview-video'
        },
        status: 'ready',
        order: 2,
        duration: 15,
        description: 'Video hướng dẫn các quy định an toàn bay'
      },
      {
        id: 'content_3',
        title: 'Bài học tương tác SCORM',
        type: 'scorm',
        file: {
          name: 'bai-hoc-tuong-tac.zip',
          size: 10485760,
          url: '#preview-scorm'
        },
        status: 'ready',
        order: 3,
        description: 'Bài học tương tác về quy trình vận hành'
      }
    ];
  },

  uploadBookContent: (bookId: string, contentData: any): Promise<any> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newContent = {
          ...contentData,
          id: `content_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          status: 'ready',
          file: {
            ...contentData.file,
            url: '#preview-url'
          }
        };
        resolve(newContent);
      }, 2000);
    });
  },

  deleteBookContent: (bookId: string, contentId: string): Promise<void> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 500);
    });
  },

  updateBookContent: (bookId: string, contentId: string, contentData: any): Promise<any> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const updatedContent = {
          ...contentData,
          id: contentId,
          lastModified: new Date().toISOString()
        };
        resolve(updatedContent);
      }, 800);
    });
  },
};